export default [
  {
    code: 'id',
    name: 'id',
    type: 'id',
  },
  {
    code: 'login',
    name: 'user_name',
    type: 'input',
  },
  {
    code: 'email',
    name: 'email',
    type: 'input',
  },
  {
    code: 'lastName',
    name: 'last_name',
    type: 'input',
  },
  {
    code: 'firstName',
    name: 'first_name',
    type: 'input',
  },
  {
    code: 'tel',
    name: 'phone',
    type: 'input',
  },
  {
    code: 'description',
    name: 'description',
    type: 'input',
  },
  {
    code: 'status',
    name: 'status',
    type: 'select',
    dictionary: 'userstatus',
    itemValue: 'code',
    itemText: 'name',
  },
]
